/**
 * API functions for LaTeX report generation
 */

import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "http://127.0.0.1:8000/api/";

// Template management
export const getTemplates = (token) =>
  axios.get(`${API_URL}latex-templates/`, {
    headers: { Authorization: `Token ${token}` },
  });

export const getTemplate = (token, id) =>
  axios.get(`${API_URL}latex-templates/${id}/`, {
    headers: { Authorization: `Token ${token}` },
  });

export const createTemplate = (token, templateData) =>
  axios.post(`${API_URL}latex-templates/`, templateData, {
    headers: { Authorization: `Token ${token}` },
  });

export const updateTemplate = (token, id, templateData) =>
  axios.put(`${API_URL}latex-templates/${id}/`, templateData, {
    headers: { Authorization: `Token ${token}` },
  });

export const deleteTemplate = (token, id) =>
  axios.delete(`${API_URL}latex-templates/${id}/`, {
    headers: { Authorization: `Token ${token}` },
  });

export const getDefaultTemplates = (token) =>
  axios.get(`${API_URL}latex-templates/default_templates/`, {
    headers: { Authorization: `Token ${token}` },
  });

export const setAsDefault = (token, id) =>
  axios.post(`${API_URL}latex-templates/${id}/set_as_default/`, {}, {
    headers: { Authorization: `Token ${token}` },
  });

// Report generation
export const generateReport = (token, reportData) =>
  axios.post(`${API_URL}reports/generate/`, reportData, {
    headers: { Authorization: `Token ${token}` },
  });

// Generated reports management
export const getGeneratedReports = (token, params = {}) =>
  axios.get(`${API_URL}generated-reports/`, {
    headers: { Authorization: `Token ${token}` },
    params
  });

export const getGeneratedReport = (token, id) =>
  axios.get(`${API_URL}generated-reports/${id}/`, {
    headers: { Authorization: `Token ${token}` },
  });

export const downloadPdf = (token, id) =>
  axios.get(`${API_URL}generated-reports/${id}/download_pdf/`, {
    headers: { Authorization: `Token ${token}` },
    responseType: 'blob',
  });

export const downloadLatex = (token, id) =>
  axios.get(`${API_URL}generated-reports/${id}/download_latex/`, {
    headers: { Authorization: `Token ${token}` },
    responseType: 'blob',
  });

// Assignment-specific reports
export const getAssignmentReports = (token, assignmentId) =>
  axios.get(`${API_URL}assignments/${assignmentId}/reports/`, {
    headers: { Authorization: `Token ${token}` },
  });

// Template preview functionality
export const getPreviewOptions = (token) =>
  axios.get(`${API_URL}latex-templates/preview/`, {
    headers: { Authorization: `Token ${token}` },
  });

export const generatePreview = (token, previewData) =>
  axios.post(`${API_URL}latex-templates/preview/`, previewData, {
    headers: { Authorization: `Token ${token}` },
    responseType: 'blob', // Important for PDF response
  });